import AWS from "../../images/AWS_Logo.png";

export const SkillsData = [
    {
        type: "Backend",
        list: [
            {
                name: "C",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg"
            },
            {
                name: "C++",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
            },
            {
                name: "Java",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg"
            },
            {
                name: "Python",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
            },
            {
                name: "JavaScript",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
            }
        ]
    },
    {
        type: "Web Dev",
        list: [
            {
                name: "HTML",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
            },
            {
                name: "CSS",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
            },
            {
                name: "JavaScript",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
            },
            {
                name: "MERN Stack",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg"
            },
            {
                name: "APIs",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swagger/swagger-original.svg" // Updated icon link
            }
        ]
    },
    {
        type: "Database",
        list: [
            {
                name: "SQL",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg"
            },
            {
                name: "MongoDB",
                icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
            }
        ]
    },
    {
        type: "Cloud Computing",
        list: [
            {
                name: "AWS Cloud Practitioner",
                icon: AWS
            }
        ]
    }
];
